/* eslint-disable no-unused-vars */
import React, { Component, forwardRef } from 'react';
// import PropTypes from 'prop-types';
/* eslint-enable no-unused-vars */

import styled from 'styled-components';

import { BreakPoint, Color, FontSize } from '../../../../../asset/styles';

const StyledTextarea = styled.textarea`
  border: solid 1px ${Color.gray};
  border-radius: 4px;
  box-sizing: border-box;
  caret-color: ${Color.red};
  color: ${Color.text.darkGray};
  font-size: ${FontSize.medium};
  height: 96px;
  line-height: 1.6875;
  padding: 8px 16px;
  width: 100%;
  margin-top: 8px;

  @media (max-width: ${BreakPoint.small}) {
    font-size: ${FontSize.smallDevice.medium};
  }
  @media (min-width: ${BreakPoint.desktop}) {
    outline: none;
  }
`;

/**
 * {@link Inquiry} - free message textarea
 * - 入力文字を RAY 送信するために `ref` 使用します
 * @type {React.ComponentType<{} & React.ClassAttributes<any>>}
 * @return {*} React.node - {@link Inquiry} - free message textarea
 */
const FreeTextarea = forwardRef((props, ref) => (
  <StyledTextarea innerRef={ref} {...props} />
));

export default FreeTextarea;



// WEBPACK FOOTER //
// ./src/phase2/survey/page/inquiry/node/body/free/FreeTextarea.js